import React from 'react';
import { voyageDropdownService, VoyageDropdownItem } from '../../services';
import { EntityPickerModal } from './EntityPickerModal';
import { createMultiFieldFilter } from '../../search/filterBuilders';
import { formatDate } from '../../utils/tableUtils';

interface ChangeVoyageModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (voyageId: string) => void;
  carCount: number;
}

export const ChangeVoyageModal: React.FC<ChangeVoyageModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  carCount
}) => {
  return (
    <EntityPickerModal<VoyageDropdownItem>
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Change Voyage"
      description={`Select a voyage to move ${carCount} ${carCount === 1 ? 'car' : 'cars'}`}
      confirmLabel="Change Voyage"
      placeholder="Search voyages..."
      loadOptions={async () => voyageDropdownService.getAll({ limit: 1000 })}
      getKey={(v) => v.id}
      getPrimary={(v) => (
        <div>
          <div className="font-semibold text-gray-900 dark:text-gray-100">{v.voyage_code}</div>
          <div className="text-sm text-gray-600 dark:text-gray-400">{v.vessel_description}</div>
        </div>
      )}
      getSecondary={(v) => (
        <div className="text-right">
          <p>Departure: {formatDate(v.departure)}</p>
          <p>Currency: {v.currency}</p>
        </div>
      )}
      filter={createMultiFieldFilter<VoyageDropdownItem>(
        v => v.voyage_code,
        v => v.vessel_description
      )}
    />
  );
};

